import { EstimationUnit } from '@atlassian/jira-insights-common-constants/src/common/utils/constants.tsx';
import type { TimeTrackingOptions } from '@atlassian/jira-time-tracking-formatter/src/types.tsx';
import { TimeFormats, TimeUnits } from '@atlassian/jira-time-tracking-formatter/src/constants.tsx';

export const BEACON_ID = 'sprint-commitment';

export const ARTICLE_ID_NOT_SUPPORTED_ESTIMATION_CMP = '6brtL6Kql0YzSBOpfc96Bx';
export const ARTICLE_ID_NOT_SUPPORTED_ESTIMATION_TMP = '1Qh9BVeOgie6iCQEEWe7Ng';
export const ARTICLE_ID = '5GAjYfj1sNAmiG6ajBmZ8k';
export const ERROR_MESSAGE = 'No estimations';

export const ARTICLE_ID_NO_SPRINT_CMP = '7oORaI2BNlPTvZaUnzJV71';
export const ARTICLE_ID_NO_SPRINT_TMP = '17PhFKPmse8Z7KWZcPMulA';

export const supportedEstimationTypes = [
	EstimationUnit.STORY_POINTS,
	EstimationUnit.ISSUE_COUNT,
	EstimationUnit.TIME_TRACKING,
];

export const SPRINT_COMMITMENT_INFO_PANEL_ID = 'insights.sprint-commitment.info-panel.id';

export const RecommendationStatus = {
	BELOW_TARGET: 'BELOW_TARGET',
	ABOVE_TARGET: 'ABOVE_TARGET',
	WITHIN_TARGET: 'WITHIN_TARGET',
	NO_TARGET: 'NO_TARGET',
} as const;

const RECALCULATING = 'RECALCULATING';

export const responseTypes = {
	SUCCESS: 'SUCCESS',
	RECALCULATING,
} as const;

export const SPRINT_COMMITMENT_RECALCULATING = {
	type: responseTypes.RECALCULATING,
} as const;

export const TIME_FORMAT_DEFAULT: TimeTrackingOptions = {
	workingDaysPerWeek: 0,
	workingHoursPerDay: 0,
	timeFormat: TimeFormats.PRETTY,
	defaultUnit: TimeUnits.HOUR,
} as const;
